import { userLanguage } from '@glow/common/utils/language'
import { setup } from '@glow/language'
import i18n from 'i18next'
import { Settings } from 'luxon'
import dk from './dk'
import en from './en'
import fi from './fi'
import fr from './fr'
import nb from './nb'
import sv from './sv'

setup()
// Here rather than where dates are formatted: modules that load at startup run before this one, while i18next has no
// language yet
Settings.defaultLocale = userLanguage()
i18n.addResourceBundle('en', 'translation', en)
i18n.addResourceBundle('sv', 'translation', sv)
i18n.addResourceBundle('nb', 'translation', nb)
i18n.addResourceBundle('dk', 'translation', dk)
i18n.addResourceBundle('fi', 'translation', fi)
i18n.addResourceBundle('fr', 'translation', fr)
